export const environment = {
  production: true,
  version: "v2025-05-09 22:28:05.038303",
};
